import { render, staticRenderFns } from "./resources.cattle.io.restore.vue?vue&type=template&id=7cdfa2e5&"
import script from "./resources.cattle.io.restore.vue?vue&type=script&lang=js&"
export * from "./resources.cattle.io.restore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports